"use client";
import { useEffect, useRef, type ReactNode } from "react";
/** Deep links open the matching native preview; all instructions remain server-rendered. */
export default function MissionStarterPreview({
  id,
  name,
  children,
}: {
  id: string;
  name: string;
  children: ReactNode;
}) {
  const ref = useRef<HTMLDetailsElement>(null);
  useEffect(() => {
    const reveal = () => {
      if (window.location.hash === `#${id}` && ref.current)
        ref.current.open = true;
    };
    reveal();
    window.addEventListener("hashchange", reveal);
    return () => window.removeEventListener("hashchange", reveal);
  }, [id]);
  return (
    <details ref={ref} className="mt-5">
      <summary className="cursor-pointer font-semibold text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent">
        Preview {name}
      </summary>
      {children}
    </details>
  );
}
